import React, { createContext } from "react";

export const ChatContext = createContext({});
